// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_inputError__JRLdF {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_inputContainer__2xCLj {
  margin-bottom: 20px;
}

.styles_wrapper__-QkXh {
  width: 100%;
}

.styles_formContainer__--uTb > div {
  max-width: 400px;
}

.styles_extraMargin__ByC6N {
  margin-top: 10px;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 20px;
}

.styles_serverError__SuPaF {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__SuPaF span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_inputStyle__LoKfe {
  width: 420px;
  height: 44px;
}

.styles_containerPadding__O0\\+Ns {
  padding-right: 2rem;
  padding-left: 2rem;
}

@media only screen and (max-width: 800px) {
  .styles_containerPadding__O0\\+Ns {
    max-width: 450px;
    margin: 0 auto;
    padding: 0;
  }
}
.styles_submitItem__2IEje {
  margin: 0 5px !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border-radius: 6px !important;
  background-color: inherit !important;
  font-size: 16px !important;
  line-height: 25px !important;
  height: auto !important;
}

.styles_submitItem__2IEje span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

@media only screen and (max-width: 800px) {
  .styles_submitItem__2IEje {
    border: none;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 19px !important;
    width: 100%;
    border: unset !important;
  }
}
.styles_bottomTexts__STR2g {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 9px;
}

.styles_bottomTexts__STR2g > p:nth-child(1) {
  margin: 5px;
}

.styles_haveAccount__yufGS {
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: auto;
  display: flex;
  margin-top: 14px;
  margin-bottom: 40px;
}

.styles_formContainer__--uTb {
  border-left-width: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: auto;
  display: flex;
  padding: 20px;
}

.styles_flexStyle__K3C\\+A {
  flex-direction: row;
  border-radius: 10px;
  height: auto;
  width: auto !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles_extraMargin__ByC6N {
  margin-top: 10px;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 20px;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__K3C\\+A {
    flex-direction: column;
  }
  .styles_flexStyle__K3C\\+A > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__--uTb {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_force_media__FVks7 {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__K3C\\+A {
    flex-direction: column-reverse;
    overflow: auto;
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__K3C\\+A::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__K3C\\+A::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__K3C\\+A > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SignUp/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EAGE,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAEF;;AAAA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGF;;AAAA;EACE,YAAA;EACA,YAAA;AAGF;;AAAA;EACE,mBAAA;EACA,kBAAA;AAGF;;AACA;EACE;IACE,gBAAA;IAEA,cAAA;IACA,UAAA;EACF;AACF;AAGA;EACE,wBAAA;EACA,eAAA;EACA,2BAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,uBAAA;AAJF;;AAMA;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAMA;EAEE;IACE,YAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;IACA,4BAAA;IACA,WAAA;IACA,wBAAA;EAJF;AACF;AAMA;EAEE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAOA;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAMA;EACE,sBAAA;EAGA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EAEA,aAAA;AANF;;AAWA;EACE,mBAAA;EAGA,mBAAA;EAGF,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAZA;;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAXF;;AAeA;EACE;IACE,sBAAA;EAZF;EAeA;IACE,cAAA;IACA,gBAAA;EAbF;EAeA;IACE,sBAAA;EAbF;AACF;AAiBA;EACE;IACE,iCAAA;EAfF;EAiBA;IACE,8BAAA;IACA,cAAA;IAEA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EAlBF;EAoBA;IAEE,uBAAA;IACA,UAAA;EAnBF;EAsBA;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EApBF;EAuBA;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EArBF;AACF","sourcesContent":[".inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n.inputContainer{\n  margin-bottom:20px;\n}\n.wrapper{\n  width:100%;\n}\n.formContainer>div{\n  // min-width:30vw;\n  // min-width:30vw;\n  max-width:400px;\n\n}\n.extraMargin{\n  margin-top:10px;\n  margin-bottom:0;\n  font-weight: bold;\n  font-size: 20px;\n}\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.inputStyle {\n  width: 420px;\n  height: 44px;\n}\n\n.containerPadding {\n  padding-right: 2rem;\n  padding-left: 2rem;\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .containerPadding {\n    max-width: 450px;\n\n    margin: 0 auto;\n    padding: 0;\n    // padding-right: 1.5rem;\n    // padding-left: 1.5rem;\n  }\n}\n.submitItem {\n  margin: 0 5px !important;\n  cursor: pointer;\n  flex-direction: row-reverse;\n  // border: 1px solid #d8000d !important;\n  border-radius: 6px !important;\n  background-color: inherit !important;\n\n  font-size: 16px !important;\n  line-height: 25px !important;\n  // color: #e30813 !important;\n  height: auto !important;\n}\n.submitItem span {\n  // color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n@media only screen and (max-width: 800px) {\n\n  .submitItem {\n    border: none;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    font-size: 12px !important;\n    line-height: 19px !important;\n    width: 100%;\n    border: unset !important;\n  }\n}\n.bottomTexts{\n  // color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top:9px;\n  // min-width:128px;\n}\n.bottomTexts>p:nth-child(1){\n  margin:5px;\n}\n.haveAccount {\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  width: auto;\n  display: flex;\n  margin-top: 14px;\n  margin-bottom: 40px;\n}\n.formContainer {\n  border-left-width: 2px;\n  // padding-left: 1.5rem;\n  // padding-right: 1.5rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: auto;\n  display: flex;\n\n  padding: 20px;\n\n}\n\n\n.flexStyle {\n  flex-direction: row;\n  // margin-top:40px;\n\n  border-radius: 10px;\n// border: 1px solid rgba(0, 0, 0, 0.50);\n// background: #FFF;\nheight:auto;\nwidth:auto !important;\nmargin-top:10px;\nmargin-bottom:10px;\n}\n.extraMargin{\n  margin-top:10px;\n  margin-bottom:0;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n\n@media only screen and (max-width: 1024px) {\n  .flexStyle {\n    flex-direction: column;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0 auto;\n    margin-top: 20px;\n  }\n  .formContainer {\n    border-left-width: 0px;\n  }\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .force_media {\n    padding: 0 10px 0 10px !important;\n  }\n  .flexStyle {\n    flex-direction: column-reverse;\n    overflow: auto;\n    // height: calc( 100vh - 138px);\n    padding-bottom: 20px;\n  \n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n  .flexStyle::-webkit-scrollbar {\n  \n    background: transparent;\n    width: 8px;\n  }\n  \n  .flexStyle::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0;\n    margin-top: 20px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputError": `styles_inputError__JRLdF`,
	"inputContainer": `styles_inputContainer__2xCLj`,
	"wrapper": `styles_wrapper__-QkXh`,
	"formContainer": `styles_formContainer__--uTb`,
	"extraMargin": `styles_extraMargin__ByC6N`,
	"serverError": `styles_serverError__SuPaF`,
	"inputStyle": `styles_inputStyle__LoKfe`,
	"containerPadding": `styles_containerPadding__O0+Ns`,
	"submitItem": `styles_submitItem__2IEje`,
	"bottomTexts": `styles_bottomTexts__STR2g`,
	"haveAccount": `styles_haveAccount__yufGS`,
	"flexStyle": `styles_flexStyle__K3C+A`,
	"force_media": `styles_force_media__FVks7`
};
export default ___CSS_LOADER_EXPORT___;
